// extracted by mini-css-extract-plugin
export default {"circle":"PageLoader_circle__GRJ54","dote":"PageLoader_dote__jzdp2","animate":"PageLoader_animate__QWcML"};